/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PageOffers;
(function (PageOffers) {
    var page;
    (function (page) {
        page["FUNNEL_PAGE_PREOFFER"] = "FUNNEL_PAGE_PREOFFER";
        page["FUNNEL_PAGE_MAINOFFER"] = "FUNNEL_PAGE_MAINOFFER";
        page["FUNNEL_PAGE_PREPURCHSE"] = "FUNNEL_PAGE_PREPURCHSE";
        page["FUNNEL_PAGE_CHECKOUT"] = "FUNNEL_PAGE_CHECKOUT";
        page["FUNNEL_PAGE_POSTPURCHASE1"] = "FUNNEL_PAGE_POSTPURCHASE1";
        page["FUNNEL_PAGE_POSTPURCHASE2"] = "FUNNEL_PAGE_POSTPURCHASE2";
        page["FUNNEL_PAGE_ORDERCONFIRMATION"] = "FUNNEL_PAGE_ORDERCONFIRMATION";
    })(page = PageOffers.page || (PageOffers.page = {}));
})(PageOffers || (PageOffers = {}));
//# sourceMappingURL=PageOffers.js.map